import styled from "styled-components";

import { StandardLayout } from "@/components/layouts";
import { StyledAuthPageBody, StyledPageContainer } from "@/components/layouts/styled";
import { breakpoints } from "@/styles/breakpoints";

export const StyledConversationPage = styled.div`
    display: flex;
    flex: 1 1 auto;
    flex-direction: row;
    margin-bottom: 24px;
    overflow: hidden;
    /* .conversation-message-chat-container {
        flex: 1 0;
        height: 100%;
        @media ${breakpoints.xs} {
            width: 100%;
            padding-left: 0;
        }
    } */
    .no-conversation-selected {
        display: flex;
        flex: 1 0;
        align-items: center;
        height: 100%;
        text-align: center;
        span {
            width: 100%;
            font-size: var(--size-16);
            font-style: italic;
            color: var(--color-grey-800);
        }
    }
    .uploaded-files {
        display: flex;
        flex: 0 0 auto;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        margin-bottom: 6px;
        margin-left: 32px;
        overflow-x: auto;
        @media ${breakpoints.xs} {
            flex: 0 1 auto;
            flex-wrap: wrap;
            margin-left: 0;
        }
    }
    .conversation-upload-errors {
        padding-left: 0;
        margin-top: 0;
        margin-bottom: 5px;
        margin-left: 32px;
        color: var(--color-error);
        list-style-type: none;
        @media ${breakpoints.xs} {
            margin-left: 0;
        }
    }
`;

export const StyledMainConversation = styled(StandardLayout)`
    height: 100vh;
    ${StyledAuthPageBody} {
        display: flex;
        flex: 1 1 auto;
        overflow: hidden;
    }

    ${StyledPageContainer} {
        display: flex;
        flex: 1 1;
    }
    @media ${breakpoints.xs} {
        ${StyledAuthPageBody} {
            margin-top: 0;
            ${StyledPageContainer} {
                padding: 0;
                form {
                    padding: 0 15px;
                }
            }
        }
    }
`;
